import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  courses: [],
  course: {
    id: 0,
    topic: "",
    shortdescription: "",
    type: "",
    categoryid: 0,
    UserId: 0,
    description: "",
    format: "",
    duration: 0,
    price: 0,
    startDate: "",
    endDate: "",
    status: false,
    startTime: "",
    endTime: "",
    imageUrl: "",
    brochureUrl: "",
    zoomUrl: "",
    days: "",
    userName: "",
    image: null,
    brochure: null,
    courseCategory: {
      id: 0,
      category: "",
      status: false,
      userName: ""
    },
    courseSpeakers: {}
  },
  courseValidation: {
    isValid: true,
    topic: {
      isValid: true,
      errorMessage: "El campo tema no debe estar vacio",
    },
    shortdescription: {
      isValid: true,
      errorMessage: "El campo descripción corta no debe estar vacio",
    },
    type: {
      isValid: true,
      errorMessage: "El campo tipo no debe estar vacio",
    },
    categoryid: {
      isValid: true,
      errorMessage: "El campo categoría no debe estar vacio",
    },
    description: {
      isValid: true,
      errorMessage: "El campo descripción no debe estar vacio",
    },
    format: {
      isValid: true,
      errorMessage: "El campo formato no debe estar vacio",
    },
    duration: {
      isValid: true,
      errorMessage: "El campo duración no debe estar vacio",
    },
    price: {
      isValid: true,
      errorMessage: "El campo precio no debe estar vacio",
    },
    startDate: {
      isValid: true,
      errorMessage: "El campo fecha de inicio no debe estar vacio",
    },
    endDate: {
      isValid: true,
      errorMessage: "El campo fecha de fin no debe estar vacio",
    },
    startTime: {
      isValid: true,
      errorMessage: "El campo hora de inicio no debe estar vacio",
    },
    endTime: {
      isValid: true,
      errorMessage: "El campo hora de fin no debe estar vacio",
    },
    imageUrl: {
      isValid: true,
      errorMessage: "Debes cargar una imagen",
    },
    brochureUrl: {
      isValid: true,
      errorMessage: "Debes cargar un brochure",
    },
    zoomUrl: {
      isValid: true,
      errorMessage: "Debes cargar un zoom",
    },
    days: {
      isValid: true,
      errorMessage: "El campo días no debe estar vacio",
    },
  },
};

const courseSlice = createSlice({
    name: "course",
    initialState,
    reducers: {
      restartState(state) {
        state.course = {};
        state.courses = [];
      },
      setCourses(state, actions) {
        state.courses = actions.payload.courses;
        state.course = {};
      },
      setCourse(state, actions) {
        state.course = actions.payload.course;
        state.courses = [];
      },
      modifyPropertyValue(state, actions) {
        state.course[actions.payload.id] = actions.payload.value;
      },
      setCourseValidation(state, actions) {
        state.courseValidation = {
          topic: {
            ...state.courseValidation.name,
            isValid: actions.payload.name !== "",
          },
          shortdescription: {
            ...state.courseValidation.description,
            isValid: actions.payload.description !== "",
          },
          type: {
            ...state.courseValidation.type,
            isValid: actions.payload.type !== "",
          },
          categoryid: {
            ...state.courseValidation.categoryid,
            isValid: actions.payload.categoryid !== 0,
          },
          description: {
            ...state.courseValidation.description,
            isValid: actions.payload.description !== "",
          },
          format: {
            ...state.courseValidation.format,
            isValid: actions.payload.format !== "",
          },
          duration: {
            ...state.courseValidation.duration,
            isValid: actions.payload.duration !== 0,
          },
          price: {
            ...state.courseValidation.price,
            isValid: actions.payload.price !== 0,
          },
          startDate: {
            ...state.courseValidation.startDate,
            isValid: actions.payload.startDate !== "",
          },
          endDate: {
            ...state.courseValidation.endDate,
            isValid: actions.payload.endDate !== "",
          },
          startTime: {
            ...state.courseValidation.startTime,
            isValid: actions.payload.startTime !== "",
          },
          endTime: {
            ...state.courseValidation.endTime,
            isValid: actions.payload.endTime !== "",
          },
          imageUrl: {
            ...state.courseValidation.imageUrl,
            isValid: actions.payload.imageUrl !== "",
          },
          brochureUrl: {
            ...state.courseValidation.brochureUrl,
            isValid: actions.payload.brochureUrl !== "",
          },
          zoomUrl: {
            ...state.courseValidation.zoomUrl,
            isValid: actions.payload.zoomUrl !== "",
          },
          days: {
            ...state.courseValidation.days,
            isValid: actions.payload.days !== "",
          },
        };
        state.courseValidation.isValid =
          state.courseValidation.description.isValid;
      },
      setFieldValid(state, actions) {
        state.courseValidation[actions.payload.id].isValid = actions.payload.value;
      },
    },
  });

  
export const courseActions = courseSlice.actions;
export default courseSlice;